import { ClientAttributes } from '@pulse/common';

export class ClientAttributesService {
    private clientAttributes: ClientAttributes = {};

    constructor() {
        try {
            const pulseScript = this.getPulseScript();
            this.clientAttributes = pulseScript ? this.getClientAttributes(pulseScript) : {};
        } catch {
            // Fallback to empty attributes if initialization fails
            this.clientAttributes = {};
        }
    }

    getAttributes(): ClientAttributes {
        return this.clientAttributes;
    }

    getPulseScript(): URL | null {
        try {
            if (document?.currentScript instanceof HTMLScriptElement) {
                return new URL(document?.currentScript.src);
            } else {
                const scripts = document.getElementsByTagName('script');

                for (let i = 0; i < scripts.length; i++) {
                    const script = scripts[i];
                    const src = script.getAttribute('src');

                    if (
                        src &&
                        src.match(
                            /^(https?|http):\/\/[^/]+\/pulse\/[^/]+\/(module\/|nomodule\/)?pulse\.js/i,
                        )
                    ) {
                        return new URL(src);
                    }
                }
            }
        } catch {
            return null;
        }

        return null;
    }

    private getAttributesFromQuery(attributesFromQuery: string): ClientAttributes {
        const attributes: ClientAttributes = {};

        attributesFromQuery.split(',').forEach((pair) => {
            const [key, value] = pair.split('.');
            attributes[key] = value;
        });

        return attributes;
    }

    private getClientAttributes(url: URL): ClientAttributes {
        try {
            const searchParams = new URLSearchParams(url.search);
            const attributesFromQuery = searchParams.get('attr');

            if (!attributesFromQuery) {
                return {};
            } else {
                return this.getAttributesFromQuery(attributesFromQuery);
            }
        } catch {
            return {};
        }
    }
}
